<template>
  <!--콘텐츠 영역-->
  <div class="sub_contents">
    <a href="#sub_area" id="top_btn"></a>
    <div class="privacy_area">
      <div class="Title">
        <h4>이메일무단 수집거부</h4>
      </div>

      <div class="Text_area">
        <div class="Text">
          <p>
            당사 홈페이지 운영자 또는 관리자 및 당사의 사전동의 없이 본
            홈페이지에 게시된 전자우편 주소가 전자우편 수집 프로그램 또는 그
            밖의 기술적 장치를 이용하여 무단으로 수집되는 것을 거부하며, 이를
            위반할 시 [정보통신망 이용촉진 및 정보 보호 등에 관한 법률] 등에
            따라 형사 처벌됨을 유념하시기 바랍니다.
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data: () => ({
    message: "email.vue"
  }),
  methods: {},
  computed: {},
  destroyed() {},
  created() {
    console.log("created - " + this.message);
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/footer/Email.vue